import React from "react";
import ReactPlayer from "react-player";

const Reactplayer = ({ url }) => {
  return (
    <div className="relative pt-[56.25%]">
      <ReactPlayer
        className="absolute top-0 left-0"
        url={url}
        width="100%"
        height="100%"
        controls={true}
      />
    </div>
  );
};

export default Reactplayer;
